<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeCreate(){
	window.localStorage.setItem('language','') 
  },
    created(){
      var url = location.search; //获取url中"?"符后的字串  
        var theRequest = new Object();  
        if (url.indexOf("?") != -1) {  
          var strs='';
          var str = url.substr(1);  
          strs = str.split("&");  
          for(var i = 0; i < strs.length; i ++) {  
            theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);  
          }  
        } 
	
		if(theRequest.language){
           this.$store.state.language = theRequest.language ;
           window.localStorage.setItem('language',theRequest.language) 
           console.log('打印language',theRequest.language)
        }
        if( window.localStorage.getItem('language') ){
          this.$store.state.language = window.localStorage.getItem('language');
        }

        
  }
}
</script>

<style type="text/css">
	html, body {
		-webkit-overflow-scrolling: touch;/*惯性*/
		width: 100%;
		overflow-x: hidden;
    -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
    -webkit-user-select:none; /*webkit浏览器*/
    -khtml-user-select:none; /*早期浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none; /*IE10*/
    user-select:none;
	}
	body,td,th {
		font-family:"微软雅黑",Verdana, Arial, Helvetica, sans-serif;
		font-size: 14px;
		color: #1d1007;
		line-height:24px
	} 
	* {
		margin: 0;
		padding: 0;
	}
	img {
		display: block;
		border: none;
	}
	li {
		list-style: none;
	}
	input,
	select,
	textarea {
		outline: none;
	}
	a {
		color: #999;
		text-decoration: none;
	}
</style>
<style>
	.mint-cell{
		border-radius: 6px !important;
	}
	/*编辑器的属性*/
	.ql-align-center{
		text-align: center;
	}
	.ql-align-justify{
		text-align:justify;
	}
	.ql-align-right{
		text-align:right;
	}
	.ql-align-left{
		text-align:left;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue